import React from 'react'

const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <p className="copyright">
            ByKush &copy; {year} &mdash; Game Aggregator Platform
        </p>
    )
}

export default Footer
